import type {ColumnConfig} from 'schema/table/types';
import type {SchemaReference} from 'schemas/types';
import {getDefaultColumns} from '../functions/getDefaultColumns';

export const useDefaultColumns = (reference: SchemaReference): ColumnConfig[] =>
  getDefaultColumns(reference);
